export default{
    getReport : state => {
        return state.reportData
    }
}